import React, { useState } from 'react';
import { Card, Col, Divider, Tooltip } from 'antd';
import img1 from '../../assets/images/expert/icon1.svg';
import img2 from '../../assets/images/expert/icon2.svg';
import img3 from '../../assets/images/expert/icon3.svg';
import img4 from '../../assets/images/expert/img4.svg';
import locationimg from '../../assets/images/location.png';
import starLogo from '../../assets/images/star.svg';
import expertIcon from '../../assets/images/profile_placeholder.png';
import { breakName } from '../../helpers/functions';
import { nameRecommendationConstantForToolTip } from '../../helpers/constant';
import useResponsive from '../../hooks/useBreakpoint';
const ExpertCard = ({ item, onClick }) => {
  const breakpoint = useResponsive();
  const [showImg, setShowImg] = useState(true);
  
  const displayLang = data =>
    data.length
      ? data.map((e, idx) => {
        return idx < 5 ? (
          <span id={idx}>
             {e.name}
             {idx == data.length - 1 ? '' : ','}
          </span>
        ) : null;
      })
      : '-';

  const displayQualification = (data, nameProperty) => {
    const totalCount = data.length;

    if (totalCount) {
      const name = data[0][nameProperty];
      return (
        <span id={0}>
          {name}
          {totalCount > 1 ? <sup>+{totalCount - 1}</sup> : null}
        </span>
      );
    } else {
      return '-';
    }
  };
  const displayCategory = data => {
    if (!Array.isArray(data) || data.length === 0) {
      return <p className="mb-0 cat-title">No categories</p>;
    }

    const sorted = [...data].sort((a, b) => a.name.length - b.name.length);

    let names = [];
    let totalLength = 0;
    const maxLen = 45;

    for (const item of sorted) {
      const name = item.name;
      const separator = names.length ? ', ' : '';
      const nextLength = totalLength + separator.length + name.length;

      // if (nextLength > maxLen) break;

      names.push(name);
      totalLength = nextLength;
    }

    const remaining = sorted.length - names.length;
    const result = names.join(', ') + (remaining > 0 ? ` +${remaining}` : '');

    return <p className="mb-0 cat-title">{result}</p>;
  };
  function summarizeExpertCredentials(data, showAll = false) {
    const { degrees = [], certificates = [] } = data;

    let degreeSummary = '';
    let certificateSummary = '';

    if (showAll) {
      degreeSummary = degrees.map(d => d.name).join(', ');
      certificateSummary = certificates.map(c => c.designation).join(', ');
    } else {
      if (degrees.length > 0) {
        degreeSummary = degrees[0].name;
        if (degrees.length > 1) {
          degreeSummary += ` +${degrees.length - 1}`;
        }
      }

      if (certificates.length > 0) {
        certificateSummary = certificates[0].designation;
        if (certificates.length > 1) {
          certificateSummary += ` +${certificates.length - 1}`;
        }
      }
    }

    if (degreeSummary && certificateSummary) {
      return `${degreeSummary}, ${certificateSummary}`;
    } else {
      return degreeSummary || certificateSummary || '';
    }
  }

  const displaySubCategory = data =>
    data.length
      ? data
        .filter(
          (value, index, self) =>
            index ===
            self?.findIndex(
              prev =>
                prev.industry?.name === value.industry?.name &&
                prev.industry?.name === value.industry?.name,
            ),
        )
        .map((e, idx, self) => {
          return idx < 1 ? (
            <span id={idx}>{self.length === idx + 1 ? e.industry.name : e.industry.name}</span>
          ) : null;
        })
      : '-';
  return (
    <>
      <Col xs={24} sm={12} md={12} lg={8} xl={8} key={item.id}>
        <Card
          onMouseEnter={() => {
            // console.log("over");
            if (showImg) {
              setShowImg(false);
            }
          }}
          onMouseLeave={() => {
            // console.log("leave");
            if (!showImg) {
              setShowImg(true);
            }
          }}
          style={{ backgroundColor: '' }}
          onClick={onClick}
        >
          <div style={{ height: breakpoint == "xxl" && "550px" || breakpoint == "xl" && "600px" || breakpoint == "lg" && "600px" || breakpoint == "md" && "600px" || breakpoint == "sm" && "550px" || breakpoint == "xs" && "550px" }} className="card-parent">
            {item?.rating > 0 && (
              <div style={{ position: 'absolute', right: '30px', top: '30px' }}>
                <div
                  style={{ backgroundColor: '#f1f1f1', color: 'black' }}
                  className="profile-expert-rating-container"
                >
                  <img src={starLogo} alt="star-logo" loading="lazy" />
                  <div>{item?.rating}</div>
                </div>
              </div>
            )}
            <img
              loading="lazy"
              alt="expert"
              className={`main-img ${showImg ? 'expand-img' : 'collapse-img'}`}
              src={item?.avatar ? item?.avatar : expertIcon}
            />
            <div
              // style={{ height: '100%', overflow: 'hidden' }}
              className={`card-section mt-5 ${!showImg ? 'custom-expert-card' : ''}`}
            >
              <p className="mb-0 title">
                <Tooltip
                  title={nameRecommendationConstantForToolTip?.title || ''}
                  color={nameRecommendationConstantForToolTip?.color}
                >
                  {breakName(item?.first_name, item?.last_name)}
                </Tooltip>
              </p>

              {item.category.length ? displayCategory(item.category) : '-'}
              <Divider className="mt10 mb10" />
              <div
                className=""
                style={{
          
                  minHeight: showImg ? '160px' : '400px',
                  // height : "auto",
                  overflowY: showImg ? 'hidden' : 'auto',
                  scrollbarWidth: 'thin',
                }}
              >
                <div className="card-section2" style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    loading="lazy"
                    style={{ filter: 'grayscale(100%)', width: "22px" }}
                    src={locationimg}
                    alt="make"
                  ></img>

                  <p className="mb-0 cat-title" >
                    {
                      item?.default_location?.[0]?.name
                    }

                  </p>
                </div>

                <div className="card-section2">
                  <img src={img1} alt="make"></img>
                  <p className="mb-0 cat-title">
                    {
                      summarizeExpertCredentials(item,!showImg)
                    }
                    {/* {item?.certificates?.length
                      ? displayQualification(item.certificates, 'designation')
                      : '-'}
                    {(item?.degrees?.length && item?.certificates?.length) ? ', ' : ''}

                    {item?.degrees?.length ? displayQualification(item.degrees, 'name') : ''} */}
                  </p>
                  <p></p>
                </div>
                <div className="card-section2">
                  <img loading="lazy" src={img2} alt="make"></img>
                  <p>
                    {item.business_sector.length ? displaySubCategory(item.business_sector) : '-'}
                  </p>
                </div>
                <div className="card-section2">
                  <img loading="lazy" src={img3} alt="make"></img>

                  <p className="mb-0 cat-title">
                    {item.languages.length ? displayLang(item.languages) : '-'}
                  </p>
                </div>
                <div className="card-section2">
                  <img
                    loading="lazy"
                    style={{ filter: 'grayscale(100%)' }}
                    src={img4}
                    alt="make"
                  ></img>

                  <p className="mb-0 cat-title" style={{ lineHeight: '17px' }}>
                    {!showImg ? (
                      <>{item?.locations?.length ?  item?.locations.map(l => l.name).join(', ') :  item?.default_location?.[0]?.name}</>
                    ) : (
                      <>
                        {item?.locations?.length ? item?.locations
                          .slice(0, 3)
                          .map(l => l.name)
                          .join(', ') :  item?.default_location?.[0]?.name}
                        {item?.locations.length > 3 ? ` +${item?.locations.length - 3}` : ''}
                      </>
                    )}
                  </p>
                </div>
                {!showImg && (
                  <div style={{ marginTop: '10px', paddingRight: '20px' }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                        flexDirection: 'column',
                      }}
                    >
                      <p className="mb-0 cat-title" style={{ flex: 1, lineHeight: '17px' }}>
                        {item?.bio?.length > 450 ? `${item.bio.slice(0, 450)}...` : item?.bio}
                      </p>

                      {item?.bio?.length > 450 && (
                        <span style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                          Read more
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Card>
      </Col>
    </>
  );
};

export default ExpertCard;
